<div class="content-container bg-white">
  <h1>{{ 'ewallet.closures.title' | translate }}</h1>


  @if (modes.length > 0) {
    <div [formGroup]="periodicClosureFormGroup" class="row mb-4">
      <h4>{{ 'ewallet.closures.periodicScheduleActivationTitle' | translate }}</h4>
      @for (mode of modes.controls; track mode) {
        <ng-container formArrayName="modes">
          <div class="default-filter-form-field" [formGroup]="mode">
            <label class="form-label" for="state-{{mode.value.mode}}">{{ 'ewallet.closures.enums.EwalletClosureScheduleMode.' + mode.value.mode | translate}}</label>
            <div class="form-check form-switch">
              <input class="form-check-input" id="state-{{mode.value.mode}}" type="checkbox"
                [formControl]="mode.controls.enabled"
                (change)="setPeriodicClosureMode(mode.value.mode, mode.value.enabled)">
                <label class="form-check-label" for="state-{{mode.value.mode}}">
                  {{ (mode.value.enabled ? 'common.enabled' : 'common.disabled') | translate }}
                </label>
              </div>
            </div>
          </ng-container>
        }
      </div>
    }

    <h4>{{ 'ewallet.closures.scheduledClosuresTitle' | translate }}</h4>

    <div class="btn-bar">
      <button class="btn btn-primary"
        (click)="openClosureScheduleModal()"
        translate="ewallet.closures.add">
      </button>
    </div>

    <div class="table-responsive mb-5">
      @if (scheduledClosures) {
        <table class="table table-striped"
          [attr.aria-label]="'ewallet.closures.title' | translate">
          <thead>
            <tr>
              <th scope="col" style="min-width:250px" translate="ewallet.closures.nextExecution"></th>
              <th scope="col" style="min-width:325px" translate="ewallet.closures.type"></th>
              <th scope="col" style="min-width:100px"></th>
            </tr>
          </thead>
          <tbody>
            @if (scheduledClosures.length === 0) {
              <tr>
                <td>-</td>
                <td>-</td>
                <td></td>
              </tr>
            }
            @for (item of scheduledClosures; track item) {
              <tr>
                <td class="align-middle">{{ item.scheduledDateTime | date: DateUtils.dateTimeWithoutSecondFormat }}</td>
                <td class="align-middle" translate="{{ 'ewallet.closures.enums.EwalletClosureScheduleMode.' + item.mode }}"></td>
                <td class="align-middle text-end">
                  @if (item.mode === EwalletClosureScheduleMode.Scheduled) {
                    <button class="btn btn-link btn-sm"
                      (click)="openClosureScheduleModal(item)"
                      title="{{'common.tooltip.edit' | translate}}">
                      <fa-icon [icon]="icons.edit"></fa-icon>
                    </button>
                    <button class="btn btn-link btn-sm"
                      (click)="deleteItem(item)"
                      title="{{'common.tooltip.delete' | translate}}">
                      <fa-icon [icon]="icons.delete"></fa-icon>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>

    <app-ewallet-closure-documents></app-ewallet-closure-documents>
  </div>


